import React, { useState } from 'react';
import Title from 'antd/es/typography/Title';

import { Button, Space, Table, } from "antd";
import * as libCon from "../community-hats-js-library/Constants.js"
import { LoadingGoveeActivationCodes } from '../components/LoadingDatasets.js';
import { useEffect } from 'react';
import { fetchGoveeActivationCodes } from '../store/actions/datasetActions.js';
import { RefStoredValue } from '../hooks/GeneralStoreHooks.js';
import { formatDistanceToNow } from 'date-fns';
import { RefContextLanguage } from '../providers/LanguageProvider.js';
import { tField } from '../utils/translationFunctions.js';


const getGeneralColumns = (i18n) => [
  {
    title: tField(i18n, libCon.ATF_DATE_CREATED),
    dataIndex: libCon.ATF_DATE_CREATED,
    sorter: (a, b) => a[libCon.ATF_SCORE] - b[libCon.ATF_SCORE],
    align: 'center',
    width: 100,
    render: (val) => formatDistanceToNow(new Date(val), { addSuffix: true })
  },
  {
    title: tField(i18n, libCon.ATF_ACTIVATION_CODE),
    dataIndex: libCon.ATF_ACTIVATION_CODE,
    align: 'center',
    width: 100,
  }

]


function DashboardGoveeActivationCodes() {

  useEffect(() => {
    fetchGoveeActivationCodes()
  }, [])


  const codes = RefStoredValue(libCon.DATASET_GOVEE_ACTIVATION_CODES)
  const codeStatus = RefStoredValue(libCon.STATUS_DATASET_GOVEE_ACTIVATION_CODES)


  const i18n = RefContextLanguage()

  const [latestCodes, setLatestCodes] = useState([])

  useEffect(() => {

    if (codeStatus === libCon.OK) {
      const sortedLatest = Object.values(codes)
        .sort((a, b) => new Date(b[libCon.ATF_DATE_CREATED]) - new Date(a[libCon.ATF_DATE_CREATED]))
        .slice(0, 10);

      setLatestCodes(sortedLatest)

    }

  }, [codes, codeStatus])



  return (
    <div className="mainContainer" >
      <Title level={3}>{i18n.t('goveeActivationCodes')}</Title>
      <Button type="primary" onClick={() => fetchGoveeActivationCodes()}>{i18n.t('refresh')}</Button>

      {
        codeStatus !== libCon.OK
          ? <LoadingGoveeActivationCodes />
          : <div style={{ marginRight: "30%", marginLeft: "30%" }}>
            <Space direction="horizontal" >
              <Table style={{ minWidth: "50vw" }} dataSource={latestCodes} columns={getGeneralColumns(i18n)} pagination={false} />
            </Space>



          </div>
      }

    </div>
  )

}


export default DashboardGoveeActivationCodes